import { lazy } from 'react';

/** Загружает страницу бонусного счёта */
export const BonusAccountDetailsPageAsync = lazy(() => import('./BonusAccountDetails/BonusAccountDetailsPage'));
